import { render } from "./UserLoginForm.vue?vue&type=template&id=5ab965dd"
import script from "./UserLoginForm.vue?vue&type=script&lang=js"
export * from "./UserLoginForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\cbt-project\\candidate.dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__